var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 5.5H4C3.46957 5.5 2.96086 5.71071 2.58579 6.08579C2.21071 6.46086 2 6.96957 2 7.5V25.5C2 26.0304 2.21071 26.5391 2.58579 26.9142C2.96086 27.2893 3.46957 27.5 4 27.5H28C28.5304 27.5 29.0391 27.2893 29.4142 26.9142C29.7893 26.5391 30 26.0304 30 25.5V7.5C30 6.96957 29.7893 6.46086 29.4142 6.08579C29.0391 5.71071 28.5304 5.5 28 5.5ZM26.586 7.5L16.707 17.379C16.5195 17.5665 16.2652 17.6718 16 17.6718C15.7348 17.6718 15.4805 17.5665 15.293 17.379L5.414 7.5H26.586ZM4 25.5V8.914L13.879 18.793C14.4416 19.3554 15.2045 19.6714 16 19.6714C16.7955 19.6714 17.5584 19.3554 18.121 18.793L28 8.914V25.5H4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ce60f798ef0d482401b896a3af30398a.svg";
export { ForwardRef as ReactComponent };